/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

const DEFAULT_RECOMMENDATION_TYPE = 'AZ Product';

const productRecommendationTypeList = {
  certona: 'Certona',
  sponsoredProduct: 'Sponsored Product',
  affinity: 'Affinity',
  buyAgain: 'Buy Again',
} as const;

type ProductRecommendationType = keyof typeof productRecommendationTypeList;

const isProductRecommendationType = (value: string): value is ProductRecommendationType =>
  Object.hasOwn(productRecommendationTypeList, value);

export const getProductRecommendationType = (productType: string | null): string => {
  if (!productType || !isProductRecommendationType(productType)) {
    return DEFAULT_RECOMMENDATION_TYPE;
  }

  return productRecommendationTypeList[productType];
};
